export default "__VITE_ASSET__dfd9fea3__"